import expertAvatar from '../asset/avatar.png';



// 默认视频封面图片 - 使用 Unsplash 高质量图片
export const DEFAULT_VIDEO_COVER = 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=640&h=360&q=80';

// 默认优秀案例封面图片 - 使用 Unsplash 高质量图片
export const DEFAULT_CASE_COVER = 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=640&h=360&q=80';

export const MOCK_USER_INFO = {
    id: '2005616044210696193',
    userName: '学员1号',
    phoneNo: '18967894321',
    avatar: '',
    email: 'test@qq.com',
    registerLogList: [],
    roleCode: 'personal',
    userType: 1,
    state: 1,
    token: 'mock_token_' + Date.now()
}

export const EXPERT_DEFAULT_AVATAR = expertAvatar;


export const CONSULTATION_TYPE = [
    { code: 'JSZX', desc: '技术咨询' },
    { code: 'BZJD', desc: '标准解读' },
    { code: 'LCZD', desc: '流程指导' },
    { code: 'SBXG', desc: '设备相关' },
    { code: 'QTWT', desc: '其他问题' },
]

export const MESSAGE_TYPE = [
    { code: 'SYSTEM', desc: '系统通知' },
    { code: 'EXPERT_CONSULTATION', desc: '专家咨询' },
    { code: 'CONSULTATION', desc: '咨询回复' },
    { code: 'ENROLLMENT', desc: '报名通知' },
    { code: 'SUGGESTION', desc: '建议消息' },
    { code: 'COURSE', desc: '课程通知' },
]

export const USER_TYPE = {
    'personal': { type: 1, code: 'personal', desc: '普通用户' },
    'expert': { type: 2, code: 'expert', desc: '专家' },
    'company': { type: 3, code: 'company', desc: '机构' },
    'practitioner': { type: 4, code: 'practitioner', desc: '机构从业人员' },
}

// 控制台外部链接
export const CONSOLE_URL = 'https://console.example.com';

// 监管登录外部链接
export const SUPERVISION_LOGIN_URL = process.env.REACT_APP_ENV === 'dev' ? 'http://60.165.149.117:7001' : 'https://admin.qyscjg.cn/login';


// export const FAVORITE_TYPE = [
//     { key: 'institution', code: 'ORG', name: '检验检测机构', label: '机构' },
//     { key: 'knowledge', code: 'KNOWLEDGE', name: '知识库', label: '知识' },
//     { key: 'expert', code: 'TEACHER', name: '专家', label: '专家' },
//     { key: 'case', code: 'CASE', name: '优秀案例', label: '案例' },
//     { key: 'trainingCourse', code: 'COURSE', name: '培训课程', label: '培训课程' },
//     { key: 'trainingVideo', code: 'TRAINING', name: '培训视频', label: '培训视频' },
// ]
